<ng-container *ngFor="let item of orderByData; let i = index;">
  <div class="d-flex flex-fill" [ngClass]="item.isSelected ? 'gap-3' : ''">
    <fpc-button class="flex-fill" [text]="item.label" [buttonColorClass]="'outline-primary'" [buttonClass]="'w-100 text-start'" [active]="item.isSelected"
      (buttonClick)="item.isSelected ? setClassDirection(item) : onCategoryClick(item)"></fpc-button>

    <fpc-button [buttonLayoutType]="'icon'" [buttonColorClass]="'outline-primary'" [buttonClass]="'w-100 h-100 px-4'"
      [title]="[item.orderDirection == 'Ascending' ? 'Ascending' : 'Descending']" [active]="item.orderDirection == 'Ascending' ? false : true"
      [customNgClass]="item.isSelected ? 'd-flex' : 'd-none'" (buttonClick)="setClassDirection(item)" [iconClass]="item.orderIcon"></fpc-button>
  </div>
</ng-container>